<template>
    <div :style="'position:absolute;opacity:0;height:0;width:0;display:inline-block;' + font">.</div>
</template>


<script>
export default {
    name: "preload-font-hack",
    props: ["font"]
}
</script>